module.exports = __webpack_public_path__ + "img/tg_swper01.d7f6a13e.png";